export default __webpack_public_path__ + "static/media/service-cost-bg.d060769b.jpg";